import { z } from "zod";

import { ERROR_MSG } from "@/constants/ErrorMessage.constant";
import { basicValidator, imageValidator } from "@/lib/validators";

export const LoadType = z.object({
  id: z.string().optional(),
  name: basicValidator(true, "Load type name is required", 2, 50),
  tareWeight: z.preprocess(
    (val) => Number(val),
    z
      .number({ invalid_type_error: "Tare weight must be greater than 0" })
      .nonnegative({ message: "Tare weight cannot be negative" })
      .min(0.1, { message: "Tare weight must be greater than 0" }),
  ),
  logo: imageValidator(2, false, ERROR_MSG.REQUIRED_IMAGE),
});

export type TLoadTypeSchema = z.infer<typeof LoadType>;
